import fp from 'lodash/fp'
import React from 'react'
import PropTypes from 'prop-types'
import Modal from 'react-modal'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Button, Margin } from 'shared/components'

import * as styles from './styles'

const BaseModalComponent = ({
  style,
  opened,
  renderTrigger,
  renderBody,
  onTrigger,
  onRequestClose,
}) => {
  const dialogStyles = {
    content: {
      ...styles.dialogStyles.content,
      ...fp.prop('content', style),
    },

    overlay: {
      ...styles.dialogStyles.overlay,
      ...fp.prop('overlay', style),
    },
  }

  return (
    <>
      <Modal
        isOpen={opened}
        onRequestClose={onRequestClose}
        style={dialogStyles}
      >
        <div css={styles.header}>
          <Button plain onClick={onRequestClose}>
            <FontAwesomeIcon icon="times" />
          </Button>
        </div>
        <Margin bottom={4}>{renderBody(onRequestClose)}</Margin>
      </Modal>
      {renderTrigger(onTrigger)}
    </>
  )
}

BaseModalComponent.propTypes = {
  style: PropTypes.shape(),
  opened: PropTypes.bool.isRequired,
  renderBody: PropTypes.func.isRequired,
  renderTrigger: PropTypes.func.isRequired,
  onTrigger: PropTypes.func.isRequired,
  onRequestClose: PropTypes.func.isRequired,
}

export default BaseModalComponent
